import React, { useEffect, useState } from "react";
import { useLanguage } from "../../context/LanguageContext";

const PLACEHOLDER = "__";

const pad = (value) => {
  if (!Number.isFinite(value)) return PLACEHOLDER;
  return String(value).padStart(2, "0");
};

const getTimeLeft = (targetDate) => {
  const targetMs = targetDate ? new Date(targetDate).getTime() : NaN;
  if (!Number.isFinite(targetMs)) {
    return {
      days: null,
      hours: null,
      minutes: null,
      seconds: null,
    };
  }

  const diff = Math.max(0, targetMs - Date.now());
  const totalSeconds = Math.floor(diff / 1000);

  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
};

/**
 * Reusable countdown timer — Figma digit boxes + colon separators.
 */
const Countdown = ({ targetDate, className = "" }) => {
  const { t, language } = useLanguage();
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(targetDate));

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(getTimeLeft(targetDate));
    }, 1000);

    return () => clearInterval(timer);
  }, [targetDate]);

  const units = [
    { key: "days", label: t("countdown.days") },
    { key: "hours", label: t("countdown.hours") },
    { key: "minutes", label: t("countdown.minutes") },
    { key: "seconds", label: t("countdown.seconds") },
  ];

  return (
    <div className={`countdown ${className}`.trim()} dir={language.dir} aria-live="polite">
      {units.map(({ key, label }, index) => {
        const digits = pad(timeLeft[key]).split("");

        return (
          <React.Fragment key={key}>
            {index > 0 ? (
              <span className="countdown__separator" aria-hidden="true">
                :
              </span>
            ) : null}
            <div className="countdown__unit">
              <div className="countdown__digits" dir="ltr">
                {digits.map((digit, digitIndex) => (
                  <span className="countdown__digit" key={`${key}-${digitIndex}`}>
                    <span className="countdown__digit-face" key={digit}>
                      {digit}
                    </span>
                  </span>
                ))}
              </div>
              <span className="countdown__label">{label}</span>
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default Countdown;
